import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
/* import Vue, { VueConstructor } from 'vue'; */
import { i18n } from '@/main';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { bpcApi } from './bpc-api.service';
import ClientRouterService from '@core/services/client-router.service';
import store from '@app/store';

export default class TranslationsService {
  public translationLoaded: boolean = false;
  public messages: object;
  public $i18n;
  protected $bpcApiRouteHelper: BPCApiRouteHelper;
  protected $bpcApi: typeof bpcApi;

  constructor() {
    this.$bpcApiRouteHelper = new BPCApiRouteHelper();
    this.$bpcApi = bpcApi;
    /* this.getTranslations(); */
  }

  async getTranslations(language: string = null): Promise<BPCGenericApiResponse> {
    return new Promise((resolve, reject) => {
      const lang = language || localStorage.getItem('lang') || i18n.locale;

      this.$bpcApi.get(this.$bpcApiRouteHelper.getTranslationsPath(lang)).subscribe(
        (response: BPCGenericApiResponse) => {
          i18n.setLocaleMessage(lang, response['data'][lang]);
          i18n.locale = lang;
          this.translationLoaded = true;
          resolve(response);
        },
        error => {
          console.log(error);
          reject(error);
        },
      );
    });
  }
}

export const $translationsService = new TranslationsService();
